<p-table
  #table
  [styleClass]="styleClass"
  [scrollable]="scrollable"
  [scrollHeight]="scrollHeight"
  [(selection)]="selectedItems"
  (selectionChange)="selectedItemsChange.emit($event)"
  [autoLayout]="autoLayout"
  [rowGroupMode]="groupRowsBy ? rowGroupMode : undefined"
  [groupRowsBy]="groupRowsBy"
  [responsiveLayout]="responsiveLayout"
  [selectionMode]="selectionMode"
  [dataKey]="dataKey"
  [value]="loading ? skeletonItems : inplaceSort ? (values | orderBy: sort) : values">
  <ng-container *ngIf="filterColumns || captionTemplate">
    <ng-template pTemplate="caption">
      <div class="flex flex-wrap gap-2 justify-content-between align-items-center">
        <div
          *ngIf="filterColumns"
          class="flex-none"
          style="width: 300px">
          <crm-multi-select
            [options]="columns | filterEmpty: 'name'"
            [selectedItems]="selectedColumns | filterEmpty: 'name'"
            (panelHide)="setFilterColumns($event)"
            [showHeader]="false"
            [showClear]="false"
            optionDisabled="required"
            sort="order"
            optionLabel="label"
            placeholder="Выберите столбцы"
            dataKey="name"
            display="">
          </crm-multi-select>
        </div>
        <div
          *ngIf="captionTemplate"
          class="flex-grow-1">
          <ng-template [ngTemplateOutlet]="captionTemplate"></ng-template>
        </div>
      </div>
    </ng-template>
  </ng-container>
  <ng-template pTemplate="header">
    <ng-template
      *ngIf="headerTemplate"
      [ngTemplateOutlet]="headerTemplate"></ng-template>
    <ng-container *ngIf="!headerTemplate">
      <tr *ngIf="scrollable ? !loading : true">
        <th
          *ngIf="selectable"
          style="width: 40px !important">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </th>
        <ng-container *ngFor="let column of selectedColumns | orderBy: 'order:number'">
          <th
            [ngStyle]="column.style"
            pFrozenColumn
            [frozen]="column.isFrozen"
            [ngClass]="column.class">
            <ng-template
              [ngTemplateOutlet]="columnTemplate"
              [ngTemplateOutletContext]="{ column: column }"></ng-template>
          </th>
        </ng-container>

        <ng-template
          #columnTemplate
          let-column="column">
          <ng-container *ngIf="toColumn(column) as column">
            <div class="flex gap-1 align-items-center flex-nowrap w-full">
              <div
                *ngIf="column.sort; else notSort"
                (click)="setSort(column.sort)"
                class="cursor-pointer flex gap-1 justify-content-center align-items-center flex-nowrap {{
                  column.textStyleClass
                }}">
                {{ column.label }}
                <i [ngClass]="getSortIconClass(column.sort)"></i>
              </div>
              <ng-template #notSort>
                {{ column.label }}
              </ng-template>
            </div>
          </ng-container>
        </ng-template>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template
    pTemplate="groupheader"
    let-item
    let-rowIndex="rowIndex">
    <ng-template
      *ngIf="groupheaderTemplate"
      [ngTemplateOutlet]="groupheaderTemplate"
      [ngTemplateOutletContext]="{
        item: item,
        rowIndex: rowIndex
      }"></ng-template>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-item
    let-rowIndex="rowIndex">
    <ng-container *ngIf="!loading">
      <ng-template
        *ngIf="!selectable"
        [ngTemplateOutlet]="rowTemplate"
        [ngTemplateOutletContext]="{
          item: item,
          rowIndex: rowIndex,
          selectedCols: selectedColumnsMap
        }"></ng-template>
      <tr *ngIf="selectable">
        <td style="width: 40px !important">
          <p-tableCheckbox
            #tableCheckbox
            [value]="item"
            [disabled]="selectionDisabled && !tableCheckbox.checked"
            (click)="$event.stopPropagation()"></p-tableCheckbox>
        </td>
        <ng-template
          [ngTemplateOutlet]="rowTemplate"
          [ngTemplateOutletContext]="{
            item: item,
            rowIndex: rowIndex,
            selectedCols: selectedColumnsMap
          }"></ng-template>
      </tr>
    </ng-container>

    <tr *ngIf="loading">
      <td *ngIf="selectable">
        <p-tableCheckbox [disabled]="true"></p-tableCheckbox>
      </td>
      <td *ngFor="let col of selectedColumns">
        <p-skeleton
          [shape]="col.skeleton?.shape"
          [height]="col.skeleton?.height || '1rem'"></p-skeleton>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="footer">
    <tr *ngIf="paginationLoading">
      <td
        [colSpan]="selectable ? columns.length + 1 : columns.length"
        class="text-center">
        <p-progressSpinner
          [style]="{
            width: '50px',
            height: '50px'
          }"></p-progressSpinner>
      </td>
    </tr>
    <ng-template [ngTemplateOutlet]="footerTemplate"></ng-template>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="99">
        <div class="no-results w-full">
          <crm-no-data></crm-no-data>
          <h2 class="font-normal">По вашему запросу ничего не найдено</h2>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
